exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background:url(" + require("assets/content_bg.png") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-32ef3187!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Wrap.vue
// module id = 501
// module chunks = 0